import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useStore } from '~/store/composable';
import ConnectWeb3WalletError from './ConnectWeb3WalletError.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectWeb3WalletErrorDialog',
  setup(__props) {

const { state, commit } = useStore();
const showWeb3WalletErrorDialog = computed({
  get() {
    return state.showWeb3WalletErrorDialog;
  },
  set(newValue) {
    commit('toggleWeb3WalletErrorDialog', newValue);
  },
});

return { __sfc: true,state, commit, showWeb3WalletErrorDialog, ConnectWeb3WalletError }
}

})